import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const ridgelinePlotTool: Tool = {
  id: "ridgeline-plot",
  name: () => m.ridge_tool_name(),
  description: () => m.ridge_tool_description(),
  icon: "🏔️",
  basePath: "/ridgeline-plot",
  status: "stable",
  tags: [
    "chart",
    "plot",
    "data-visualization",
    "ridgeline-plot",
    "joyplot",
    "science",
  ],
};
